import { type StateType } from '../../states';
import { type MatchState } from '../../states/entities/matches';
import { type MultiviewState } from '../../states/multiview';
import { type MultiviewDisplayMode } from '../../types/multiview';
import { type Selector } from '../../types/selectors';

const emptyObject = {};
const emptyArr: [] = [];

export const selectMultiviewState: Selector<MultiviewState> = (state: StateType) => state.multiview ?? emptyObject;

//#region state.multiview
export const selectMultiviewDisplayOptions: Selector<Array<number>> = (state: StateType) =>
  selectMultiviewState(state).displayOptions ?? emptyArr;

export const selectMultiviewItemPerLine: Selector<number> = (state: StateType) =>
  selectMultiviewState(state).itemPerline;

export const selectMultiviewList: Selector<Array<MatchState>> = (state: StateType) =>
  selectMultiviewState(state).list ?? emptyArr;

export const selectMultiviewMode: Selector<MultiviewDisplayMode> = (state: StateType) =>
  selectMultiviewState(state).mode;

export const selectMultiviewShowMatchList: Selector<boolean> = (state: StateType) =>
  selectMultiviewState(state).showMatchList;

export const selectMultiviewShowWTV: Selector<boolean> = (state: StateType) => selectMultiviewState(state).showWTV;

export const selectMultiviewScrollToHeader: Selector<boolean> = (state: StateType) =>
  selectMultiviewState(state).scrollToHeader;

export const selectMultiviewUserOption: Selector<number> = (state: StateType) => selectMultiviewState(state).userOption;
//#endregion
